import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowser } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import 'img-comparison-slider';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.auth.userPoolId,
      userPoolClientId: environment.auth.clientId,
      loginWith: {
        oauth: {
          domain: environment.auth.domain,
          scopes: environment.auth.scopes,
          redirectSignIn: [environment.auth.redirectSignIn],
          redirectSignOut: [environment.auth.redirectSignOut],
          responseType: environment.auth.responseType as 'code' | 'token',
        },
      },
    },
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: environment.auth.cookieDomain,
    path: '/',
    expires: 365,
    sameSite: 'none',
    secure: true,
  }),
);

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err));
